import moment from 'moment'

import { InsuranceClause } from 'mobileApp/common/component/InsuranceClause'
import { PAYMENT_CLAUSE_MAP, PaymentType } from 'mobileApp/constants/constants'
import { ClauseInsurancePolicy, authStore, wbeStore } from 'mobileApp/store'
import { WbeLayout } from 'mobileApp/wbe/layout'

export const S09PremiumInfo = () => {
  const { maintainCenter } = authStore.currUser
  const { paymentType, paymentTypeDesc, currentOption } = wbeStore
  const { premium, chgDeductible } = currentOption

  const yearAmount = ((paymentType === '3Y' || paymentType === 'M') && 3) || (paymentType === '2Y' && 2) || 1

  const paymentDependentClause = PAYMENT_CLAUSE_MAP[paymentType as PaymentType]

  return (
    <WbeLayout title="繳款確認" step={3}>
      <section className="mb-3">
        {paymentType === 'M' || paymentType === '2Y' ? (
          <div>承保行動裝置無法正常使用或因不可預料之事故所致毀損</div>
        ) : (
          <div>承保行動裝置因不可預料之事故所致毀損</div>
        )}
        <div className="text-primary">（賠償方式僅限置換）</div>
      </section>

      <section className="row align-items-center mb-3">
        <div className="col-12 col-sm-4 text-primary">保險期間</div>
        <div className="col-12 col-sm-8">{`${moment().format('YYYY／M／D')} ～ ${moment()
          .add(yearAmount, 'year')
          .subtract(1, 'day')
          .format('YYYY／M／D')}`}</div>
      </section>

      <section className="row align-items-center mb-3">
        <div className="col-12 col-sm-4 text-primary">保險期間累積最高賠償次數</div>
        <div className="col-5 col-sm-2 fs_caption text-muted">
          第一年<span className="h5 text-dark px-2 m-0">3</span>次
        </div>
        {(paymentType === 'M' || paymentType === '2Y' || paymentType === '3Y') && (
          <div className="col-5 col-sm-2 fs_caption text-muted">
            第二年<span className="h5 text-dark px-2 m-0">3</span>次
          </div>
        )}
        {(paymentType === 'M' || paymentType === '3Y') && (
          <div className="col-5 col-sm-2 fs_caption text-muted">
            第三年<span className="h5 text-dark px-2 m-0">3</span>次
          </div>
        )}
      </section>

      <section className="row align-items-center mb-3">
        <div className="col-12 col-sm-4 text-primary">自負額</div>
        <div className="col-5 col-sm-4 fs_caption text-muted">
          置換<span className="h5 text-dark px-2 m-0">{chgDeductible}</span>元
        </div>
      </section>

      <section className="row align-items-center mb-3">
        <div className="col-12 col-sm-4 text-primary">指定維修中心</div>
        <div className="col-12 fs_body1 col-sm-8">{maintainCenter}</div>
      </section>

      <section className="row align-items-center mb-3">
        <div className="col-12 col-sm-4 text-primary">保險費</div>
        <div className="col-12 col-sm-8 fs_caption text-muted">
          新台幣<span className="h5 text-dark px-2 m-0">{premium}</span>元
        </div>
      </section>

      <section className="row align-items-center mb-3">
        <div className="col-sm-4 text-primary">繳款方式</div>
        <div className="col-sm-8">{paymentTypeDesc}</div>
      </section>

      {paymentDependentClause && (
        <InsuranceClause
          label="本保險契約適用附加條款"
          btnText={paymentDependentClause.title}
          modalId={paymentDependentClause.id}
          contentFn={paymentDependentClause.content}
        />
      )}

      <InsuranceClause
        label="財產保險投保人須知"
        btnText="安達產物財產保險投保人須知"
        modalId="clause_insurance_policy"
        contentFn={ClauseInsurancePolicy}
      />

      <section className="my-3 d-flex justify-content-between">
        <button type="button" className="btn btn-light" onClick={wbeStore.navi.goBack}>
          上一步
        </button>
        <button type="button" className="btn btn-secondary" onClick={wbeStore.navi.goNext}>
          下一步
        </button>
      </section>
    </WbeLayout>
  )
}
